import { useCallback } from "react";
import { queryKeys } from "../constants/constans";
import { useQuery, useQueryClient } from "react-query";
export default function useSetOrderList() {
  const queryClient = useQueryClient();
  const { data: orderList }: any = useQuery(queryKeys.orderList, () =>
    queryClient.getQueryData(queryKeys.orderList)
  );
  const setOrderList = useCallback(
    (orderList: any[]) =>
      queryClient.setQueryData(queryKeys.orderList, orderList),
    [queryClient]
  );

  return { orderList: orderList || [], setOrderList };
}
